{
  "pageTitle": "Media Unit Map",
  "search": {
    "placeholder": "Paste coordinates or type an address, e.g. Braniborska, Wroclaw",
    "submitLabel": "Search",
    "clearLabel": "Clear search",
    "coordinateHint": "Showing point: {{latitude}}, {{longitude}}",
    "invalidHint": "Paste coordinates, e.g. 52.2297, 16.1234",
    "geocodingLoading": "Searching for location...",
    "geocodingNotFound": "Location not found",
    "geocodingHint": "Showing: {{displayName}}"
  },
  "filters": {
    "toggleLabel": "Filters",
    "hideLabel": "Hide filters",
    "clearFiltersLabel": "Clear filters",
    "clearLabel": "Clear",
    "rangeMinLabel": "Min",
    "rangeMaxLabel": "Max",
    "applyLabel": "Apply",
    "foundCount": "Found:",
    "pinsLabel": "media units",
    "countLabel": "media units",
    "allLabel": "All",
    "noPhoto": "No photo",
    "availability": "Availability",
    "searchPlaceholder": "Search...",
    "selectedCountLabel": "{{n}} selected",
    "getClearAriaLabel": "Clear filter {{fieldId}}",
    "clearAllLabel": "Clear all",
    "addFilterLabel": "Add filter",
    "fields": {
      "formatCode": "Format",
      "region": "Region",
      "county": "County",
      "agglomeration": "Agglomeration",
      "city": "City",
      "supplierId": "Supplier",
      "lighting": "Lighting",
      "supplierNumber": "Supplier no.",
      "grwId": "GRW ID",
      "mediaType": "Media type",
      "location": "Location",
      "locationSearchPlaceholder": "Search region, county, agglomeration, city…",
      "locationInfoHint": "Selected areas are combined (OR) — add locations to broaden results. Other filters narrow the result.",
      "locationInfoHintLabel": "Location filter information",
      "administrativeArea": "District",
      "material": "Material",
      "multiformat": "Multiformat",
      "tags": "Tags",
      "address": "Address",
      "area": "Area",
      "width": "Width",
      "height": "Height",
      "audience": "Audience",
      "catalogPrice": "Catalog price",
      "rent": "Rent",
      "exposureCost": "Exposure cost",
      "additionalCosts": "Additional costs",
      "discountedPrice": "Discounted price",
      "lastMinutePrice": "Last minute price",
      "starterPrice": "Starter price",
      "productionCost": "Production cost",
      "installationCost": "Installation cost",
      "dismantlingCost": "Dismantling cost",
      "clientProduction": "Production",
      "clientInstallation": "Installation",
      "clientDismantling": "Dismantling",
      "clientAdditionalFees": "Additional fees",
      "notes": "Notes",
      "roadNumber": "Road number"
    }
  },
  "legend": {
    "title": "Media Unit Type",
    "types": {
      "billboard": "Billboard",
      "backlight": "Backlight",
      "citylight": "Citylight",
      "słup": "Pillar",
      "cityscroll": "Cityscroll",
      "konstrukcja": "Structure",
      "wielki format": "Large format",
      "mural": "Mural",
      "dooh": "DOOH",
      "inne": "Other"
    }
  },
  "errorState": "Failed to load map",
  "retryButton": "Try again",
  "offerContext": {
    "bar": {
      "message": "Adding to offer: {{offerName}}",
      "returnLabel": "Return to offer",
      "exitAriaLabel": "Stop adding to offer"
    }
  },
  "pinPopup": {
    "close": "Close",
    "details": "Details",
    "quickAdd": "Add to offer",
    "maps": "Map",
    "format": "Format",
    "dimensions": "Dimensions",
    "area": "Area",
    "supplier": "Supplier",
    "catalogPrice": "List price",
    "illumination": "Lighting",
    "illuminated": "Yes",
    "notIlluminated": "No",
    "noPhoto": "No photo",
    "photoAlt": "Media unit",
    "loadError": "Failed to load media unit",
    "retry": "Try again",
    "quickAddPicker": {
      "title": "Add to offer",
      "subtitle": "Select the target offer",
      "draftUnitLabel": "media units",
      "draftSummarySeparator": "•",
      "pendingUnitsLabel": "Adding",
      "targetOfferLabel": "Target offer",
      "searchPlaceholder": "Search offer",
      "createNewLinkLabel": "Add new",
      "changeSelectionLabel": "Change",
      "cancelChangeLabel": "Cancel change",
      "backToExistingLabel": "Back to existing",
      "lastUsedHintLabel": "The last used offer is selected by default.",
      "destinationLabel": "Adding to",
      "creationStatusHintLabel": "A new offer will be created on save.",
      "noPreselectionLabel": "No offer selected yet.",
      "noDraftsLabel": "No draft offers.",
      "noPermissionLabel": "You don't have permission to edit offers.",
      "noResultsLabel": "No offer matches your search.",
      "createNewLabel": "New offer",
      "createNewHint": "Create a new draft offer.",
      "clientFieldLabel": "Client",
      "clientFieldPlaceholder": "Select client",
      "salespersonFieldLabel": "Salesperson",
      "salespersonFieldPlaceholder": "Select salesperson",
      "salespersonFieldLockedHint": "You don't have permission to assign this offer to another salesperson.",
      "campaignDurationLabel": "Campaign duration",
      "campaignDurationPlaceholder": "Select date range",
      "campaignDurationInvalidRangeLabel": "End date must be on or after the start date",
      "confirmExistingLabel": "Add",
      "confirmNewLabel": "Create and add",
      "cancelLabel": "Cancel",
      "openFullFormLabel": "Open full form",
      "openFullFormHint": "Further configuration in the full form.",
      "validationClientRequiredLabel": "Select a client"
    }
  },
  "pois": {
    "categories": {
      "amenity-school": "Schools",
      "amenity-kindergarten": "Kindergartens",
      "amenity-hospital": "Hospitals",
      "amenity-clinic": "Clinics",
      "amenity-pharmacy": "Pharmacies",
      "shop-supermarket": "Supermarkets",
      "shop-convenience": "Convenience stores",
      "shop-grocery": "Grocery stores",
      "shop-mall": "Shopping malls",
      "amenity-fuel": "Fuel stations",
      "railway-station": "Railway stations",
      "aeroway-aerodrome": "Airports",
      "amenity-university": "Universities",
      "amenity-college": "Colleges",
      "amenity-bank": "Banks",
      "amenity-atm": "ATMs",
      "leisure-park": "Parks",
      "office-government": "Government offices",
      "amenity-townhall": "Town halls",
      "tourism-attraction": "Tourist attractions",
      "tourism-museum": "Museums",
      "amenity-place_of_worship": "Places of worship"
    },
    "layerPanel": {
      "showPois": "POI layers",
      "close": "Close"
    },
    "popup": {
      "searchWithin": "Search within radius",
      "radiusMeters": "{{meters}}m",
      "radiusKm": "{{km}}km",
      "brand": "Brand",
      "close": "Close"
    },
    "nearbySection": {
      "heading": "Nearby POIs",
      "empty": "No nearby points of interest",
      "distanceM": "{{distance}}m"
    },
    "filterSection": {
      "label": "Near POI",
      "categoryLabel": "Category",
      "radiusLabel": "Radius",
      "categoryPlaceholder": "Select category...",
      "categorySearchPlaceholder": "Search category...",
      "categoryNoResults": "No results",
      "radiusPlaceholder": "Select radius...",
      "applyLabel": "Apply",
      "activePill": "Nearby: {{label}} ({{radius}})",
      "nearPoiPill": "Within {{radius}} of POI: {{name}}",
      "unknownPoi": "POI"
    }
  },
  "transportLayers": {
    "nearbyTitle": "Nearby transport",
    "lineInfo": {
      "closeAriaLabel": "Close"
    },
    "controls": {
      "sectionLabel": "Transport layers",
      "publicTransportLabel": "Public transport",
      "roadsLabel": "Major roads",
      "zoomHintPublic": "Zoom in to see transport",
      "zoomHintRoads": "Zoom in to see roads",
      "loadingLabel": "Loading...",
      "emptyLabel": "No data in this area"
    },
    "legend": {
      "publicTransport": "Public transport",
      "roads": "Major roads"
    },
    "modeLabels": {
      "road": "National road - main corridor",
      "autobusy": "Public transport - bus",
      "tramwaje": "Public transport - tram",
      "kolej-metro": "Public transport - rail / metro",
      "metro": "Public transport - metro",
      "unknown": "Public transport - OSM relation"
    }
  },
  "administrativeAreaLayer": {
    "controls": {
      "toggleLabel": "Administrative areas",
      "errorLabel": "Failed to load administrative-area boundaries"
    }
  },
  "areaSelection": {
    "pageTitle": "Map - area selection",
    "tools": {
      "pan": "Pan map",
      "lasso": "Lasso",
      "rectangle": "Rectangle",
      "circle": "Circle",
      "modeAdd": "Add to selection",
      "modeRemove": "Remove from selection",
      "modeFresh": "Replace selection",
      "lassoAdd": "Lasso: add to selection",
      "lassoRemove": "Lasso: remove from selection",
      "rectangleAdd": "Rectangle: add to selection",
      "circleAdd": "Circle: add to selection",
      "clearShapes": "Clear all shapes",
      "polygon": "Polygon",
      "pointSelect": "Click-select",
      "shortcut": {
        "pan": "V",
        "lasso": "L",
        "rectangle": "R",
        "circle": "C",
        "polygon": "P",
        "pointSelect": "S"
      }
    },
    "selectionCard": {
      "selectedCount": "{{count}} media units selected",
      "visibleCount": "{{count}} visible",
      "clearSelection": "Clear selection",
      "saveToOffer": "Save to offer...",
      "bulkDownload": "Download specifications"
    },
    "drawBadge": "{{count}} media units",
    "emptyShapeToast": "0 media units in shape",
    "saveDialog": {
      "title": "Save to draft offer",
      "createNew": "Create new draft offer",
      "confirmButton": "Add {{count}} media units to offer",
      "cancelButton": "Cancel",
      "close": "Close"
    },
    "successToast": "{{count}} media units added to {{offerName}}",
    "filterToggle": "Filters",
    "hideFilters": "Hide filters",
    "clearFilters": "Clear filters",
    "foundCount": "Found:",
    "pinsLabel": "media units"
  },
  "admin": {
    "pois": {
      "pageTitle": "Geographic data",
      "heading": "Points of interest",
      "addButton": "Add POI",
      "deleteButton": "Delete",
      "makePublicButton": "Set as public",
      "makeInternalButton": "Set as internal",
      "viewOnMapButton": "View on map",
      "deleteConfirm": "Are you sure you want to delete POI {{name}}?",
      "internal": "Internal",
      "columns": {
        "name": "Name",
        "category": "Category",
        "internalOnly": "Internal",
        "createdAt": "Added"
      },
      "form": {
        "nameRequired": "Name is required",
        "categoryRequired": "Category is required",
        "nameLabel": "Name",
        "categoryLabel": "Category",
        "latLabel": "Latitude",
        "lngLabel": "Longitude",
        "internalOnlyLabel": "Internal only",
        "namePlaceholder": "e.g. Primary School No. 1",
        "categoryPlaceholder": "Select category...",
        "latError": "Latitude must be between -90 and 90",
        "lngError": "Longitude must be between -180 and 180",
        "submitLabel": "Add POI",
        "submittingLabel": "Adding...",
        "apiError": "An error occurred. Try again."
      },
      "toast": {
        "createSuccess": "POI added",
        "deleteSuccess": "POI deleted",
        "deleteError": "Failed to delete POI. Try again."
      },
      "deleteDialog": {
        "title": "Delete POI",
        "confirm": "Delete",
        "cancel": "Cancel"
      },
      "allCategories": "All categories",
      "categoryFilterLabel": "Filter by category",
      "showDeletedLabel": "Show deleted",
      "showListLabel": "Show list",
      "hideListLabel": "Hide list",
      "deletedBadge": "Deleted",
      "stats": {
        "osmCount": "POIs from OpenStreetMap",
        "customCount": "Custom POIs",
        "deletedCount": "Deleted",
        "lastImport": "Last import",
        "neverImported": "No data",
        "categoryBreakdown": "Category breakdown",
        "manageCta": "Manage custom POIs",
        "manageDesc": "Add and remove your own points of interest that do not come from OpenStreetMap.",
        "importNote": "OSM data is imported automatically every Sunday at 02:00 UTC. You can also trigger import manually with task worker:poi-import."
      },
      "importTrigger": {
        "triggerButton": "Run import",
        "triggerButtonRunning": "Import in progress...",
        "statusLabel": "Import status",
        "statusIdle": "Idle",
        "statusRunning": "Running",
        "statusCompleted": "Completed",
        "statusFailed": "Error",
        "lastRunAt": "Last run",
        "lastError": "Last error",
        "triggerSuccess": "POI import started",
        "triggerError": "Failed to start import",
        "triggerConflict": "Import already in progress"
      }
    },
    "transportLayers": {
      "importTrigger": {
        "triggerButton": "Run import",
        "triggerButtonRunning": "Import in progress...",
        "statusLabel": "Transport layers import",
        "statusIdle": "Idle",
        "statusRunning": "Running",
        "statusCompleted": "Completed",
        "statusFailed": "Error",
        "lastRunAt": "Last run",
        "lastError": "Last error",
        "triggerSuccess": "Transport layer import started",
        "triggerError": "Failed to start transport layer import",
        "triggerConflict": "Transport layer import already in progress"
      }
    },
    "adminBoundaries": {
      "importTrigger": {
        "title": "Administrative boundaries import",
        "description": "Load the reference data for Polish regions and counties. The import is idempotent: re-running does not create duplicates.",
        "triggerButton": "Run import",
        "triggerButtonRunning": "Import in progress...",
        "statusIdle": "Idle",
        "statusRunning": "Running",
        "statusCompleted": "Completed",
        "statusFailed": "Error",
        "lastRunAt": "Last run",
        "lastError": "Last error",
        "resultSummary": "Inserted {{inserted}}, skipped {{skipped}}",
        "triggerError": "Failed to start administrative boundaries import",
        "triggerConflict": "Administrative boundaries import already in progress"
      }
    }
  }
}
